module.exports = __webpack_public_path__ + "static/4-285801b16535401454631202032c7209.jpg";